
/* injects from baggage-loader */

export const getSwarmSetRfidPinCodeRequest = params => ({
    name: "SetRFIDPin",
    params,
});

export const getSwarmRfidPinLoginNeededRequest = params => ({
    name: "CheckIfRFIDPinNeededOnLogin",
    params,
});